import type { FC, PropsWithChildren } from 'react';

const BaseCardSZ: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="mx-auto w-full max-w-[540px]">
      <div className="min-h-12 w-full sm:bg-white shadow-none transition-all overflow-hidden sm:rounded-small sm:shadow-card">
        {children}
      </div>
    </div>
  );
};

export { BaseCardSZ };
